import { fillPlaceholders } from '@debbie/common/dist/lang/placeholders.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { z } from 'zod/v4';
import { useUrlState } from '../../utils/url-state.js';
import Select from '../Select.js';
const PERIOD_DAYS = [7, 30, 90, 180];
const DEFAULT_PERIOD_DAYS = 30;
// Whole days including today: the query key stays stable within a day and
// moves on at midnight with the next render.
export const periodOf = (days) => ({
    from: moment()
        .subtract(days - 1, 'days')
        .startOf('day')
        .toISOString(),
    to: moment().add(1, 'day').startOf('day').toISOString(),
});
// The same number of days, ending where the current period starts.
export const previousPeriodOf = (days) => ({
    from: moment()
        .subtract(2 * days - 1, 'days')
        .startOf('day')
        .toISOString(),
    to: moment()
        .subtract(days - 1, 'days')
        .startOf('day')
        .toISOString(),
});
export const useReportPeriodDays = () => useUrlState('days', z.literal(PERIOD_DAYS), DEFAULT_PERIOD_DAYS);
const Field = styled.div `
  width: 180px;
  margin-left: auto;
`;
export const ReportPeriodSelect = ({ days, onChange }) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Field, null,
        React.createElement(Select, { searchThreshold: PERIOD_DAYS.length, options: PERIOD_DAYS.map((option) => ({
                value: `${option}`,
                label: fillPlaceholders(lang.insights.lastDays, { days: option }),
            })), selected: [`${days}`], onChange: (selected) => {
                const selectedDays = PERIOD_DAYS.find((option) => `${option}` === selected[0]);
                if (selectedDays != null) {
                    onChange(selectedDays);
                }
            } })));
};
//# sourceMappingURL=ReportPeriod.js.map